/** Fixed audience codes with tenant-editable labels (Amendment A). */
export const AUDIENCE_CODES = {
  public: 1,
  prospects: 2,
  members: 3,
  staff: 4,
} as const;

export type AudienceKey = keyof typeof AUDIENCE_CODES;
export type AudienceCode = (typeof AUDIENCE_CODES)[AudienceKey];

/** Industry-neutral fallback labels (templates seed their own); tenants rename these. */
export const DEFAULT_AUDIENCE_LABELS: Readonly<Record<AudienceCode, string>> = {
  1: "Public",
  2: "Prospects",
  3: "Members",
  4: "Staff",
};
